import React from 'react'
import '../../shared/shared.css'
import Search from '../../shared/search/Search'
import { useNavigate, Link } from 'react-router-dom'
import { useTableUtils } from '../../shared/contexts/TableUtilsContext'
import config from '../../config/config'

// Function based component rendering the Privacy Policy page
function PrivacyPage() {
  const navigate = useNavigate()
  const { tableUtils, setTableUtils } = useTableUtils()

  // Set the query in the utils context and navigate to the datapage
  const search = (query) => {
    setTableUtils({ ...tableUtils, search: query })
    if (query !== '') {
      navigate(config.routes.main.data);
    }
  }

  return (
    // Privacy page content, contains article containers
    <div className="med-info-content">
      <Search update={search} />
      <section className="med-content-container">
        <h1>Privacy Policy</h1>
        <p>Effective date: 13 October 2026</p>
        <hr className="med-top-separator" />

        <p>Your privacy is important to us. This Privacy Policy explains how we collect, use and protect your data when you use our website.</p>

        <h2>1. Information We Collect</h2>
        <p>We respect your privacy and do not track your activity across the web or collect personal information such as your name or email address through our search functionality. Our website does not link individual search queries to user accounts, so we cannot identify which account submitted a particular query.</p>
        <p>To provide and improve our search functionality, we temporarily store the text of search queries. We also record limited login information, including login times and IP addresses, for security purposes, such as helping detect suspicious or unauthorised access.</p>

        <h2>2. Use of Search Queries and Login Information</h2>
        <p>The search queries you enter may be stored temporarily for the purpose of:</p>
        <ul>
          <li>Improving the accuracy and relevance of search results.</li>
          <li>Analysing popular search terms and trends to enhance the user experience.</li>
        </ul>
        <p>Login information, including login timestamps and IP addresses, is used for security purposes, such as monitoring access to the website and helping identify suspicious or unauthorised activity.</p>
        <p>We do not use search queries to create a profile of individual users, and we do not track your activity across the web.</p>

        <h2>3. Data Retention</h2>
        <p>Search queries are retained for a limited time (180 days) and are then automatically deleted from our servers. Login information is retained only for as long as necessary to support website security and related operational needs, after which it is deleted or anonymised where appropriate.</p>

        <h2>4. Data Sharing with Third Parties</h2>
        <p>We do not sell, rent, or share your data with third parties. This includes search queries and login information, such as login timestamps and IP addresses. Your data is used solely for the purposes described in this Privacy Policy, including providing and improving our search functionality and maintaining website security.</p>
        <p>We do not provide third parties with access to your stored search queries or login information for their own purposes.</p>

        <h2>5. Data Security</h2>
        <p>We employ reasonable security measures to safeguard stored search queries and login information against unauthorised access. However, given the inherent limitations of internet data transmission, absolute security cannot be guaranteed.</p>

        <h2>6. Cookies</h2>
        <p>Our website may use cookies to improve your experience. Cookies are small data files stored on your device that help us remember your preferences, such as saved selections and filter settings, and enhance the functionality of our site. You can disable cookies through your browser settings, but doing so may affect your experience on our website.</p>

        <h2>7. Your Rights</h2>
        <p>If you wish to inquire about the data we store or request its deletion, you can contact us using the contact information provided below.</p>

        <h2>8. Changes to This Privacy Policy</h2>
        <p>We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, legal or regulatory reasons. When we make changes, we will update the "Effective date" at the top of this page.</p>

        <h2>9. Contact Us</h2>
        <p>If you have any questions about this Privacy Policy or would like to contact us regarding your data, please contact us at:</p>
        <p>Email address: <strong>EMRD@uu.nl</strong></p>
      </section>
    </div>
  )
}

export default PrivacyPage